import { type FC, type JSX } from 'react';

import { type TooltipProps } from '@craft/ui/components/tooltips';

import { NotClearedTooltip } from '@/src/components/atoms/NotClearedTooltip';
import { useSelectedRole } from '@/src/features/auth/hooks';

interface EvaluatorNotClearedTooltipProps {
  readonly children: JSX.Element;
  readonly evaluatorFirstName: string;
  readonly isCurrentUser: boolean;
  readonly placement?: TooltipProps['placement'];
}

export const EvaluatorNotClearedTooltip: FC<EvaluatorNotClearedTooltipProps> = ({
  children,
  evaluatorFirstName,
  isCurrentUser,
  placement,
}) => {
  const { organizationName } = useSelectedRole();

  const title = isCurrentUser
    ? 'Your account is not cleared for this program. Please review ' +
      `${organizationName}'s clearance requirements.`
    : `${evaluatorFirstName}'s account is not cleared for this program. ` +
      `Please review ${organizationName}'s clearance requirements.`;

  return (
    <NotClearedTooltip placement={placement} title={title}>
      <span>{children}</span>
    </NotClearedTooltip>
  );
};
